import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TagManager from 'react-gtm-module';
import './Unsubscribe.scss';
import { Button } from 'react-bootstrap';
import { getDataFromAPI } from '../../services/servicesClient';
import HeaderLogo from '../../layout/Header/HeaderLogo';
import '../../layout/Header/Header.scss';
import { pageTitleData, gtmDataObject } from '../../common/gtmconsts';
import { DataLayerFunction } from '../../common/dataLayerFunction';
import { bannerNameValueFunc } from '../../common/utils';
import { bannerObj } from '../../common/consts';
import { bannerDetails } from '../../reducer/BannerInfo';
import { RedirectPharmacyLink } from '../../common/selectors';
import getContextPath from '../../GlobalVariable';

const defaultIconPath = require(`../../common/images/Logo/Favicon/${bannerObj[0].favIcon}`);

function Unsubscribe() {
  const [isSuccess, setIsSuccess] = useState(true);
  const RPharmaLink = useSelector(RedirectPharmacyLink);

  const dispatch = useDispatch();
  const [logoPathFlag, setLogoPathFlag] = useState(false);

  useEffect(() => {
    const subSection1 = 'Unsubscribe User';
    DataLayerFunction(
      pageTitleData.unSubsCribeIMZ,
      pageTitleData.unSubsCribe,
      gtmDataObject.ErrorPage,
      subSection1,
    );
  }, []);
  useEffect(() => {
    const gmtID = process.env.REACT_APP_INCENTIVE_GTM_ID || 'GTM-56G2G2T';
    const tagManagerArgs = {
      gtmId: gmtID,
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  useEffect(() => {
    const bannerNameValue = bannerNameValueFunc();
    if (bannerNameValue) {
      bannerMapContent(bannerNameValue);
    }
    if (!logoPathFlag) {
      const defaultFavicon = document.getElementById('favicon');
      if (defaultFavicon !== null) {
        defaultFavicon.href = defaultIconPath;
      }
      dispatch(bannerDetails(bannerObj[0]));
    }
  }, [logoPathFlag]);

  const bannerMapContent = (bannerNameContent) => {
    bannerObj.forEach((item) => {
      if (item.bannerName === bannerNameContent) {
        setLogoPathLink(item);
        setLogoPathFlag(true);
      }
    });
  };

  const setLogoPathLink = (itemVal) => {
    // eslint-disable-next-line global-require
    const iconPath = require(`../../common/images/Logo/Favicon/${itemVal.favIcon}`);
    const favicon = document.getElementById('favicon');
    if (favicon !== null) {
      favicon.href = iconPath;
    }
    dispatch(bannerDetails(itemVal));
  };

  const getUnsubscribeFn = (incentiveObj) => {
    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('ref');
    getDataFromAPI(`unsubscribe/${uuid}`, null, 'POST', incentiveObj)
      .then((response) => {
        if (response.data.status === 'success') {
          setIsSuccess(true);
        } else {
          setIsSuccess(false);
        }
      })
      .catch((error) => {
        setIsSuccess(false);
        return error;
      });
  };
  useEffect(() => {
    getUnsubscribeFn();
  }, []);

  const handleTryAgain = () => {
    const tagManagerArgs = {
      dataLayer: {
        click: {
          event: 'v_click',
          clickType: 'try_again',
          clickText: 'pharmacy offers Try Again',
          clickCheckbox: '',
          Recommended: '',
        },
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    window.location.pathname = getContextPath();
  };

  return (
    <main>
      <HeaderLogo />
      <div className="row incentive-form-conatiner">
        <div className="section-wrapper">
          <section className="unsubscribe-wrapper">
            {isSuccess ? (
              <div>
                <div className="heading-text">
                  <h1 className="hero-text pb-3 mb-0">
                    We&apos;re sorry to see you go
                  </h1>
                </div>
                <p className="subscribe-para-text mb-0">
                  You have successfully been unsubscribed.
                </p>
                <div className="display-flex d-grid gap-2 mt-4 no-offer">
                  <a
                    id="goToPharmacy"
                    className="back-to-pharmacy GA4_CTA no-offer-btn"
                    aria-label="Back to Pharmacy, link opens in new tab"
                    size="lg"
                    href={RPharmaLink}
                    target="_blank"
                  >
                    Return to pharmacy
                  </a>
                </div>
              </div>
            ) : (
              <div>
                <div className="heading-text">
                  <h1 className="hero-text pb-3 mb-0">
                    We&apos;re experiencing technical difficulties
                  </h1>
                </div>
                <p className="subscribe-para-text mb-0">
                  Sorry about that. Try again in a little while.
                </p>
                <div className="display-flex d-grid gap-2 my-4 no-offer">
                  <a
                    id="goToPharmacy"
                    className="back-to-pharmacy GA4_CTA no-offer-btn"
                    aria-label="Back to Pharmacy, link opens in new tab"
                    size="lg"
                    href={RPharmaLink}
                    target="_blank"
                  >
                    Return to pharmacy
                  </a>
                </div>
                <div className="display-flex d-grid gap-2">
                  <Button
                    id="tryAgainErrorPage"
                    className="pharmacy-secondary-button GA4_CTA"
                    variant="primary"
                    aria-label="Try-again"
                    size="lg"
                    onClick={handleTryAgain}
                    cta_type="Pharmacy Incentives"
                  >
                    Try Again
                  </Button>
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </main>
  );
}

export default Unsubscribe;
